module.exports = __webpack_public_path__ + "img/组 4.f2fb0412.webp";